import { businessKey } from 'scenes/FinancePage/data/queryKeyFactory';

export const IO = 'IO';
export const IOBusinessKey = businessKey.query(IO);

export const details = IOBusinessKey.details();
export const logs = IOBusinessKey.logs();
export const mutations = IOBusinessKey.mutations();

export const moreInfo = mutations.moreInfo();
export const approve = mutations.approve();
export const reject = mutations.reject();
export const undo = mutations.undo();

export const download = mutations.download();
